import React from 'react'
import styles from '../CateringOrderItem.module.css'
import Banner from '../Banner'
import { getFormattedPrice } from '../../helpers/formatPrice'
import RadioButton from '../RadioButton'
import { OrderUpdateError } from '../../types/Order'

interface Props {
  originalTotalPrice: number
  error: OrderUpdateError
  onPaymentMethodChange: (paymentMethod: string) => void
}
function UpdatePaymentMethod ({ originalTotalPrice, error, onPaymentMethodChange }: Props) {
  const [selectedMethod, setSelectedMethod] = React.useState('Payex')

  const paymentMethods = [
    { id: 'Payex', label: 'Kortbetalning' },
    { id: 'InStore', label: 'Betala i butik' }
  ]

  const handleChange = (id: string) => {
    setSelectedMethod(id)
    onPaymentMethodChange(id)
  }

  return (
    <>
      <div className={styles.updatePaymentBanner}>
        <Banner
          theme={error.isError ? 'warning' : 'info'}>
          <span className={styles.bannerText}>
            {error.isError ? (
              <span className={styles.bannerTitle}>
                {error.errorText}
              </span>
            ) : selectedMethod === 'InStore' ? (
              <span className={styles.bannerTitle}>Reserverat belopp kommer att släppas direkt.</span>
            ) : (
              <>
                <span className={styles.bannerTitle}>Kortbetalning:</span> Det går inte att genomföra ändringar som ökar det reserverade beloppet på {getFormattedPrice(originalTotalPrice)}. Ändra betalsätt till &quot;betala i butik&quot; för att öka beloppet.
              </>
            )}
          </span>
        </Banner>
      </div>
      <div className={styles.updatePaymentWrapper}>
        <h4 className={styles.updateHeading}>Ändra betalsätt</h4>
        <span className={styles.updateTitle}>Betalsätt</span>
        <div className={styles.paymentRadioButtons}>
          {paymentMethods.map((method) => (
            <RadioButton
              key={method.id}
              id={method.id}
              checked={method.id === selectedMethod}
              onChange={() => handleChange(method.id)}
            >
              {method.label}
            </RadioButton>
          ))}
        </div>
      </div>
    </>
  )
}

export default UpdatePaymentMethod